/**
 * @description: API接口管理文件
 * 所有接口变量定义均以: '_API' 结尾
 * 在每个接口上面写好接口用途注释
 */

export default {
	// 用户提现接口
	WITHDRAW_BALANCE_API: '/withdrawl/balance_withdrawl',
	// 用户提现晒单列表页接口
	GET_WITHDRAW_SHARE_LIST_API: '/withdrawl/getShowWithdrawalPageInfo',
	// 用户提现晒单编辑页数据接口
	GET_SHARE_EDIT_API: '/withdrawl/doShowWithdrawalInfo',
	// 用户提现晒单编辑页数据接口
	SAVE_SHARE_EDIT_API: '/withdrawl/showWithdrawal',
	// 提现页面接口
	WITHDRAW_PAGE_INFO_API: '/withdrawl/get_page_info',
	// 判断是否能提现
	CAN_WITHDRAW_API: '/withdrawl/can_balance_withdrawl',
	// 随机体现-获取随机提现激励视频
	GET_RAND_WITHDRAW_INFO_API: '/withdrawl/get_rand_withdraw_info',
	// 获取支付渠道
	GET_PAYMENT_CHANNEL: '',
	// 获取 H5 端 AB 结果
	GET_AB_FOR_H5: '/common/get_ab_for_h5',
	// 提现盲盒上报激励视频完播结果
	POST_REWARD_VIDEO_RESULT: '/withdrawl/BlindBoxGetReward',
	// 发起提现前行为验证
	GEETEST_VALIDATE: '/Withdrawl/BehaviorValidate',
};



// WEBPACK FOOTER //
// ./src/service/api/modules/withdraw.js